export default "__VITE_ASSET__bpHPIdX8__"